import { TrendingUp, TrendingDown } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { TruncatedText } from "@/components/ui/truncated-text";
import type { RankReportKeywordChange } from "@/types";

function rankDelta(from: number, to: number) {
  return from - to;
}

interface KeywordRowProps {
  kw: RankReportKeywordChange;
  type?: "gain" | "decline";
}

export function KeywordRow({ kw }: KeywordRowProps) {
  const delta = rankDelta(kw.from, kw.to);
  const isGain = delta > 0;
  return (
    <div className="flex items-center justify-between py-1.5 text-sm">
      <TruncatedText className="text-foreground font-medium mr-3 min-w-0">{`"${kw.keyword}"`}</TruncatedText>
      <div className="flex items-center gap-2 shrink-0">
        <span className="text-muted-foreground tabular-nums text-xs">
          #{kw.from} → #{kw.to}
        </span>
        <Badge
          variant="outline"
          className={cn(
            "text-xs tabular-nums px-1.5 py-0",
            isGain
              ? "bg-status-success-soft text-foreground border-trend-positive/30"
              : "bg-status-error-soft text-foreground border-destructive/30"
          )}
        >
          {isGain ? (
            <TrendingUp className="h-3 w-3 mr-1" />
          ) : (
            <TrendingDown className="h-3 w-3 mr-1" />
          )}
          {isGain ? "+" : ""}
          {delta}
        </Badge>
      </div>
    </div>
  );
}
